// extracted by mini-css-extract-plugin
export default {"buttonBackground":"FavoriteButton_buttonBackground__cyT+C","favBase":"FavoriteButton_favBase__5jDpE","fav":"FavoriteButton_fav__bRXQE"};